import { Grid } from "@material-ui/core";
import InvestorInformationSection from "./InvestorInformationSection";
import SettlementActionSection from "./SettlementActionSection";
import SettlementBreakdownSection from "./SettlementBreakdownSection";
import SettlementChecklistModal from "./SettlementChecklistModal";
import SettlementInformationSection from "./SettlementInformationSection";
import SettlementWorkFlowTimeline from "./SettlementWorkFlowTimeline";

const SettlementDetailsContent = ({
  BOIDError,
  bankList,
  branchList,
  canUserActOnStatus,
  checkListData,
  checkListOpen,
  claimentNidError,
  control,
  copiedAccount,
  copiedBO,
  copiedMobile,
  data,
  emailError,
  enableEdit,
  filePreview,
  formData,
  getBranchList,
  handleAddRow,
  handleChange,
  handleChangeUpdatedData,
  handleCopyAccount,
  handleCopyBO,
  handleCopyMobile,
  handleDeleteRow,
  handleEditOpen,
  handlePreviewClick,
  handleSubmit,
  handleUpdateChange,
  interimList,
  issuerYearList,
  mobileError,
  nextStatusMap,
  nidError,
  openPreview,
  previousData,
  selectedBank,
  selectedBranch,
  setBOIDError,
  setBranchList,
  setCheckListData,
  setCheckListOpen,
  setData,
  setEmailError,
  setEnableEdit,
  setMobileError,
  setNidError,
  setOpenPreview,
  setSelectedBank,
  setSelectedBranch,
  setTinError,
  setUpdatedData,
  setclaimentNidError,
  setsHoldernidError,
  settlement_id,
  settlemenNoPartChangePermission,
  sHoldernidError,
  style,
  timelineRefreshKey,
  tinError,
  totalDividend,
  updateInProgress,
  updatedData,
}) => (
  <>
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <SettlementWorkFlowTimeline settlementMstId={settlement_id} refreshKey={timelineRefreshKey} />
      </Grid>

      <InvestorInformationSection
        BOIDError={BOIDError}
        bankList={bankList}
        branchList={branchList}
        canUserActOnStatus={canUserActOnStatus}
        claimentNidError={claimentNidError}
        control={control}
        copiedAccount={copiedAccount}
        copiedBO={copiedBO}
        copiedMobile={copiedMobile}
        data={data}
        emailError={emailError}
        enableEdit={enableEdit}
        getBranchList={getBranchList}
        handleChangeUpdatedData={handleChangeUpdatedData}
        handleCopyAccount={handleCopyAccount}
        handleCopyBO={handleCopyBO}
        handleCopyMobile={handleCopyMobile}
        handleEditOpen={handleEditOpen}
        handleUpdateChange={handleUpdateChange}
        mobileError={mobileError}
        nidError={nidError}
        previousData={previousData}
        selectedBank={selectedBank}
        selectedBranch={selectedBranch}
        setBOIDError={setBOIDError}
        setBranchList={setBranchList}
        setData={setData}
        setEmailError={setEmailError}
        setEnableEdit={setEnableEdit}
        setMobileError={setMobileError}
        setNidError={setNidError}
        setSelectedBank={setSelectedBank}
        setSelectedBranch={setSelectedBranch}
        setTinError={setTinError}
        setUpdatedData={setUpdatedData}
        setclaimentNidError={setclaimentNidError}
        setsHoldernidError={setsHoldernidError}
        sHoldernidError={sHoldernidError}
        tinError={tinError}
        updateInProgress={updateInProgress}
      />

      <SettlementInformationSection
        canUserActOnStatus={canUserActOnStatus}
        data={data}
        enableEdit={enableEdit}
        filePreview={filePreview}
        handlePreviewClick={handlePreviewClick}
        openPreview={openPreview}
        setData={setData}
        setOpenPreview={setOpenPreview}
        setUpdatedData={setUpdatedData}
        style={style}
        updatedData={updatedData}
      />
    </Grid>

    <Grid container spacing={2}>
      <SettlementBreakdownSection
        canUserActOnStatus={canUserActOnStatus}
        data={data}
        enableEdit={enableEdit}
        handleAddRow={handleAddRow}
        handleDeleteRow={handleDeleteRow}
        interimList={interimList}
        issuerYearList={issuerYearList}
        setData={setData}
        setUpdatedData={setUpdatedData}
        totalDividend={totalDividend}
        updatedData={updatedData}
      />

      <SettlementActionSection
        canUserActOnStatus={canUserActOnStatus}
        data={data}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        nextStatusMap={nextStatusMap}
        setCheckListOpen={setCheckListOpen}
        settlemenNoPartChangePermission={settlemenNoPartChangePermission}
      />
    </Grid>

    <SettlementChecklistModal
      checkListData={checkListData}
      checkListOpen={checkListOpen}
      data={data}
      setCheckListData={setCheckListData}
      setCheckListOpen={setCheckListOpen}
      settlement_id={settlement_id}
      style={style}
    />
  </>
);

export default SettlementDetailsContent;
